







































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class Restore extends Vue {
  @Prop() restoreClick!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleReset() {
    eventBus.$emit('closeModal');
    this.restoreClick();
  }

  get tPrefix() {
    return 'common.components.widgetConfigFormV2.labels.modals.restore';
  }
}
